<template>
  <v-layout class="filters mb-2" row wrap>
    <v-layout column bottom right floating class="fab-container--top" style="z-index: 2">
      <v-menu v-model="view.elem.menu.visible" :close-on-content-click="false" fixed fluid floating left>
        <template #activator="{ on, attrs }">
          <v-btn color="cyan" fab small dark v-bind="attrs" :title="$t('view.commons.filters.title')" class="btn_tippy_menu" v-on="on" @click="loadSelectsData">
            <em class="fas fa-filter text-md-center" />
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item avatar>
              <v-list-item-avatar>
                <v-avatar color="indigo">
                  <v-icon dark small>fas fa-filter</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t("view.commons.filters.title") }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="view.elem.menu.visible = !view.elem.menu.visible">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list>
            <!-- Selector de filtros -->
            <v-list-item>
              <v-autocomplete
                v-model="filters.selected"
                :label="$t('view.commons.filters.select')"
                :items="filterOptionsComputed"
                item-value="code"
                item-text="name"
                hide-no-data
                return-object
                deletable-chips
                clearable
                :max-height="200"
                :no-data-text="$t('view.commons.label.nodata')"
                @change="setFilter()" />
            </v-list-item>

            <!-- Select -->
            <v-flex v-if="filters.selected && filters.selected.type == 'select'" md12>
              <v-list-item>
                <v-autocomplete
                  ref="select"
                  v-model="filters.selected.selected"
                  :label="filters.selected.name"
                  :items="view.elem.select[filters.selected.code].filteredList"
                  item-value="code"
                  item-text="name"
                  hide-no-data
                  return-object
                  clearable
                  :no-data-text="$t('view.commons.label.nodata')"
                  @keyup.enter="addFilter()"
                  @change="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Select Serverside -->
            <v-flex v-if="filters.selected && filters.selected.type == 'serverside'" md12>
              <v-list-item>
                <v-autocomplete
                  ref="serverside"
                  v-model="filters.selected.selected"
                  :label="filters.selected.name"
                  :items="view.elem.select[filters.selected.code].filteredList"
                  item-value="code"
                  item-text="name"
                  hide-no-data
                  return-object
                  clearable
                  :no-data-text="$t('view.commons.label.nodata')"
                  @change="addFilter()"
                  @input.native="loadListServerside"
                  @input="search = ''" />
              </v-list-item>
            </v-flex>

            <!-- Select Multiple -->
            <v-flex v-if="filters.selected && filters.selected.type == 'multipleselect'" md12>
              <v-list-item v-for="(item, index) in filters.selected.combos" :key="index">
                <v-autocomplete
                  :ref="`multipleselect${index}`"
                  v-model="filters.selected.selected[index]"
                  :label="filters.selected.names[index]"
                  :items="view.elem.select[filters.selected.combos[index]].filteredList"
                  item-value="code"
                  item-text="name"
                  hide-no-data
                  return-object
                  clearable
                  :no-data-text="$t('view.commons.label.nodata')"
                  @keyup.enter="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Number -->
            <v-flex v-if="filters.selected && filters.selected.type == 'number'" md12>
              <v-list-item>
                <v-text-field ref="number" v-model.trim="filters.selected.selected" :label="filters.selected.name" onkeypress="return /^[0-9]*$/.test(event.key);" @keyup.enter="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Text -->
            <v-flex v-if="filters.selected && filters.selected.type == 'text'" md12>
              <v-list-item>
                <v-text-field ref="text" v-model.trim="filters.selected.selected" :label="filters.selected.name" @keyup.enter="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Multi Number -->
            <v-flex v-if="filters.selected && filters.selected.type == 'multinumber'" md12>
              <v-list-item>
                <v-text-field ref="multinumber" v-model.trim="filters.selected.selected" :label="filters.selected.name" @keyup.enter="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Multi Text -->
            <v-flex v-if="filters.selected && filters.selected.type == 'multitext'" md12>
              <v-list-item>
                <v-text-field ref="multitext" v-model.trim="filters.selected.selected" :label="filters.selected.name" @keyup.enter="addFilter()" />
              </v-list-item>
            </v-flex>

            <!-- Si/No -->
            <v-flex v-if="filters.selected && filters.selected.type == 'sino'" md12>
              <v-list-item>
                <v-switch ref="sino" v-model.trim="filters.selected.selected" :label="filters.selected.name" input-value="true" color="primary" />
              </v-list-item>
            </v-flex>

            <!-- Date -->
            <v-flex v-if="filters.selected && filters.selected.type == 'date'" md12>
              <v-list-item class="mb-3">
                <v-flex>
                  <datePicker
                    ref="dateDateIni"
                    :key="refreshkey"
                    :name="'ini'"
                    :label="$t('view.commons.filters.dateini')"
                    :value.sync="filters.selected.selected.ini"
                    :max="filters.selected.selected.end"
                    @changeDate="changeDate" />
                </v-flex>
              </v-list-item>
              <v-list-item>
                <v-flex>
                  <datePicker
                    ref="dateDateEnd"
                    :key="refreshkey"
                    :name="'end'"
                    :label="$t('view.commons.filters.dateend')"
                    :value.sync="filters.selected.selected.end"
                    :min="filters.selected.selected.ini"
                    :enable-today="new Date(filters.selected.selected.ini) <= new Date()"
                    @changeDate="changeDate" />
                </v-flex>
              </v-list-item>
            </v-flex>

            <!-- Period -->
            <v-flex v-if="filters.selected && filters.selected.type == 'period'" md12>
              <v-list-item class="mb-3">
                <v-flex>
                  <datePicker
                    ref="datePeriodIni"
                    :key="refreshkey"
                    :type="'month'"
                    :name="'ini'"
                    :label="$t('view.commons.filters.periodini')"
                    :value.sync="filters.selected.selected.ini"
                    :max="filters.selected.selected.end"
                    @changeDate="changeDate" />
                </v-flex>
              </v-list-item>
              <v-list-item>
                <v-flex>
                  <datePicker
                    ref="datePeriodEnd"
                    :key="refreshkey"
                    :type="'month'"
                    :name="'end'"
                    :label="$t('view.commons.filters.periodend')"
                    :value.sync="filters.selected.selected.end"
                    :min="filters.selected.selected.ini"
                    :enable-today="new Date(filters.selected.selected.ini) <= new Date()"
                    @changeDate="changeDate" />
                </v-flex>
              </v-list-item>
            </v-flex>

            <!-- Rangue -->
            <v-flex v-if="filters.selected && filters.selected.type == 'rangue'" md12>
              <v-list-item>
                <v-layout row wrap class="mx-0 my-0">
                  <v-flex xs12>
                    <v-label class="mt-3">{{ filters.selected.name }}</v-label>
                  </v-flex>
                  <v-flex xs12>
                    <v-range-slider ref="rangueNumber" v-model="filters.selected.selected" :max="filters.selected.max" :min="filters.selected.min" ticks="always">
                      <template #thumb-label="props">
                        {{ props.value }}
                      </template>
                    </v-range-slider>
                  </v-flex>
                </v-layout>
              </v-list-item>
            </v-flex>

            <!-- Rating -->
            <v-flex v-if="filters.selected && filters.selected.type == 'rating'" md12>
              <v-list-item>
                <v-layout row wrap class="mx-0 my-0">
                  <v-flex xs12>
                    <v-label class="mt-3">{{ filters.selected.name }}</v-label>
                  </v-flex>
                  <v-flex xs12>
                    <v-rating v-model.trim="filters.selected.selected" color="warning" background-color="warning" empty-icon="far fa-star" full-icon="fas fa-star" small clearable />
                  </v-flex>
                </v-layout>
              </v-list-item>
            </v-flex>

            <!-- Money -->
            <v-flex v-if="filters.selected && filters.selected.type == 'money'" md12>
              <v-list-item class="mb-3">
                <v-flex>
                  <moneyField
                    ref="moneyFieldIni"
                    :key="refreshkey"
                    :name="'ini'"
                    :label="$t('view.commons.filters.moneyini')"
                    :value.sync="filters.selected.selected.ini"
                    :max="filters.selected.selected.end"
                    @changeMoney="changeMoney" />
                </v-flex>
              </v-list-item>
              <v-list-item>
                <v-flex>
                  <moneyField
                    ref="moneyFieldEnd"
                    :key="refreshkey"
                    :name="'end'"
                    :label="$t('view.commons.filters.moneyend')"
                    :value.sync="filters.selected.selected.end"
                    :min="filters.selected.selected.ini"
                    @changeMoney="changeMoney" />
                </v-flex>
              </v-list-item>
            </v-flex>
          </v-list>
          <v-card-actions justify-end>
            <v-btn v-if="filters.chips.length > 0" color="indigo" fab small dark elevation="0" :title="$t('view.commons.filters.clear')" class="btn_tippy" @click="removeAllFilters()">
              <v-icon small>fas fa-eraser</v-icon>
            </v-btn>
            <v-btn color="green" fab small dark elevation="0" :title="$t('view.commons.filters.add')" class="btn_tippy" @click="addFilter()">
              <v-icon small>fas fa-plus</v-icon>
            </v-btn>
            <v-btn
              v-if="filters.selected && filters.selected.andor"
              fab
              small
              elevation="0"
              :title="getAndOrText(filters.selected.andor)"
              class="btn_tippy"
              @click="addOr(getAndOrText(filters.selected.andor))">
              <v-icon small>fas fa-random</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-layout>
    <v-layout v-if="filters.chips && filters.chips.length > 0" justify-center flex-wrap class="mt-2">
      <v-chip v-for="(chip, index) in filters.chips" :key="index" small close value md-3 class="mr-1 mt-2" @click:close="removeFilter(chip)">
        <v-avatar small left color="primary" class="chipicon">
          <v-icon small dark>{{ chip.icon }}</v-icon>
        </v-avatar>
        {{ typeof chip.value == "object" ? chip.value.name || chip.value.text : chip.text }}
      </v-chip>
      <v-chip small close value md-3 class="mr-1 mt-2" dark color="indigo" @click:close="removeAllFilters()">
        {{ $t("view.commons.filters.clear") }}
      </v-chip>
    </v-layout>
  </v-layout>
</template>
<script>
import DatePicker from "@/components/forms/DatePicker"; /** *******************************/
import MoneyField from "@/components/forms/MoneyField"; /** *******************************/
import debounce from "debounce";
import tippy from "tippy.js";

let that;

export default {
  name: "FiltersMaster"
  , components: { DatePicker, MoneyField }
  , props: {
    select: {
      default: null
      , type: Object
    }
    , filtersdef: {
      default: null
      , type: Object
    }
    , options: {
      default: null
      , type: Array
    }
  }
  , data() {
    return {
      refreshkey: 0
      , view: {
        elem: {
          menu: { visible: false }
          , select: this.select
        }
      }
      , filtros: this.filtersdef
      , filters: {
        selected: {
          code: -1
          , type: ""
          , selected: ""
        }
        , chips: []
        , options: this.options
      }
    };
  }
  , computed: {
    filterOptionsComputed() {
      return this.filters.options.filter((value) => !value.disabled);
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, animation: "scale", placement: "left" }));
    that = this;
  }
  , methods: {
    set(filter, value) {
      if (this.filterOptionsComputed && this.filterOptionsComputed.some((i) => i.code == filter)) {
        this.filters.selected = this.filterOptionsComputed.find((i) => i.code == filter);
        this.addFilters(`${value}`.trim(), `${value}`);
        this.refreshData();
      }
    }
    , addFilter() {
      if (this.filters.selected != null && this.filters.selected.type) {
        if (this.filters.selected.type == "multinumber") {
          this.filters.selected.selected.split(",").forEach((value) => {
            this.addFilters(value.replaceAll(/\D/g, ""), value);
          });
          this.refreshData();
        } else if (this.filters.selected.type == "multitext") {
          this.filters.selected.selected.split(",").forEach((value) => {
            this.addFilters(value.trim(), value);
          });
          this.refreshData();
        } else {
          this.addFilters();
          this.refreshData();
        }
      }
    }
    , addFilters(value = this.filters.selected.selected, text = this.filters.selected.selected) {
      let chip = {};

      if (value == undefined || value == null) return false;
      if (typeof value == "object" && Object.keys(value).length === 0) return false;

      switch (this.filters.selected.type) {
      case "select":
        chip = {
          icon: this.filters.selected.icon
          , value: value.code
          , text: `${this.filters.selected.name}: ${value.name}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected = {};
        this.view.elem.select[this.filters.selected.code].filteredList = this.view.elem.select[this.filters.selected.code].filteredList.filter((item) => item.code != value.code);
        break;

      case "serverside":
        chip = {
          icon: this.filters.selected.icon
          , value: value.code
          , text: `${this.filters.selected.name}: ${value.name}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected = {};
        break;

      case "multipleselect": {
        const objs = Object.values(value);
        const values = objs.map((item) => item.code).join(";");
        const names = objs.map((item) => item.name).join(" ");
        chip = {
          icon: this.filters.selected.icon
          , value: values.includes(";") ? values : `${values}; `
          , text: `${this.filters.selected.name}: ${names}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected = {};
        break;
      }
      case "text":
      case "number":
      case "multinumber":
      case "multitext":
        chip = {
          icon: this.filters.selected.icon
          , value: value
          , text: `${this.filters.selected.name}: ${text}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected = "";
        break;

      case "sino":
        chip = {
          icon: this.filters.selected.icon
          , value: value
          , text: `${this.filters.selected.name}: ${value ? this.$t("view.commons.filters.yes") : this.$t("view.commons.filters.no")}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected = false;
        break;

      case "date":
        chip = {
          icon: this.filters.selected.icon
          , value: `(${value.ini}|${value.end})`
          , text: `${this.filters.selected.name}: ${value.ini} ~ ${value.end}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected.ini = "";
        this.filters.selected.selected.end = "";
        this.refreshkey += 1;
        break;

      case "period":
        chip = {
          icon: this.filters.selected.icon
          , value: `(${value.ini.replace("-", "")}|${value.end.replace("-", "")})`
          , text: `${this.filters.selected.name}: ${value.ini} ~ ${value.end}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected.ini = "";
        this.filters.selected.selected.end = "";
        this.refreshkey += 1;
        break;

      case "rangue":
        chip = {
          icon: this.filters.selected.icon
          , value: `(${value[0]}|${value[1]})`
          , text: `${this.filters.selected.name}: ${value[0]} ~ ${value[1]}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        break;

      case "rating":
        chip = {
          icon: this.filters.selected.icon
          , value: `${value}`
          , text: `${this.filters.selected.name}: ${value}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        break;

      case "money":
        chip = {
          icon: this.filters.selected.icon
          , value: `(${Number(value.ini)}|${Number(value.end)})`
          , text: `${this.filters.selected.name}: ${value.ini} ~ ${value.end}`
          , key: this.filters.selected.code
          , type: this.filters.selected.type
        };
        this.filters.selected.selected.ini = 0;
        this.filters.selected.selected.end = 0;
        this.refreshkey += 1;
        break;
      }

      if (chip.value != null && this.filtros[this.filters.selected.code] && !this.filtros[this.filters.selected.code].includes(chip.value)) {
        this.filters.chips.push(chip);
        this.filtros[this.filters.selected.code].push(chip.value);
      }
    }
    , addOr(text) {
      const key = this.filters.selected.code + "andor";

      let chip = {
        icon: "fas fa-random"
        , value: "true"
        , text: `${this.filters.selected.name}: ${text}`
        , key
        , type: this.filters.selected.type
      };

      if (!this.filtros[key] || (this.filtros[key] && !this.filtros[key].includes("true"))) {
        chip.andor = this.filters.selected.andor;
        this.filters.chips.push(chip);
        this.filtros[key] = [chip.value];
        this.filters.selected.andor = text;
      } else {
        this.removeFilter(chip);
        this.filters.selected.andor = text;
      }
      this.refreshData();
    }
    , refreshData() {
      this.$emit("filter", this.filtros);
    }
    , removeFilter(chip) {
      this.filters.chips = this.filters.chips.filter(function (el) {
        return el.key != chip.key || (el.key == chip.key && el.value != chip.value);
      });
      this.filtros[chip.key] = this.filtros[chip.key].filter(function (el) {
        return el != chip.value;
      });
      if (chip.type == "select" && this.view.elem.select[chip.key]) {
        this.view.elem.select[chip.key].filteredList.push(this.view.elem.select[chip.key].completeList.find((item) => item.code == chip.value));
      }
      if (chip.andor) {
        this.filters.selected.andor = this.getAndOrText(this.filters.selected.andor);
      }
      this.refreshData();
    }
    , removeAllFilters() {
      this.filters.chips = [];
      Object.keys(this.filtros).forEach((key) => (this.filtros[key] = []));
      Object.keys(this.view.elem.select).forEach((key) => (this.view.elem.select[key].filteredList = this.view.elem.select[key].completeList));
      this.$emit("filter", this.filtros);
      this.resetFilters();
    }
    , resetFilters() {
      if (this.filters.selected.type == "select") {
        this.filters.selected.selected = {};
      }
      if (this.filters.selected.type == "date") {
        this.filters.selected.selected.ini = "";
        this.filters.selected.selected.end = "";
        this.refreshkey += 1;
      }
      if (this.filters.selected.type == "period") {
        this.filters.selected.selected.ini = "";
        this.filters.selected.selected.end = "";
      }
      if (this.filters.selected.type == "money") {
        this.filters.selected.selected.ini = 0;
        this.filters.selected.selected.end = 0;
      }
      this.filters.selected = { code: -1, type: "" };
    }
    , setFilter() {
      if (this.filters.selected && this.filters.selected.type && this.$refs[this.filters.selected.type]) {
        this.$nextTick(() => this.$refs[this.filters.selected.type].$refs.input.focus());
      }
    }
    , changeDate(field, value) {
      this.filters.selected.selected[field] = value;
      this.changeDateIni();
      this.changePeriodIni();
    }
    , changeDateIni() {
      if (new Date(this.filters.selected.selected.end) < new Date(this.filters.selected.selected.ini)) {
        this.filters.selected.selected.end = this.filters.selected.selected.ini;
        this.refreshkey += 1;
      }
    }
    , changePeriodIni() {
      if (new Date(this.filters.selected.selected.end) < new Date(this.filters.selected.selected.ini)) {
        this.filters.selected.selected.end = this.filters.selected.selected.ini;
        this.refreshkey += 1;
      }
    }
    , changeMoney(field, value) {
      this.filters.selected.selected[field] = Number(value);
      this.changeMoneyIni();
    }
    , changeMoneyIni() {
      if (Number(this.filters.selected.selected.end) < Number(this.filters.selected.selected.ini)) {
        this.filters.selected.selected.end = this.filters.selected.selected.ini;
        this.refreshkey += 1;
      }
    }
    , loadSelectsData() {
      this.$emit("loadSelectsData");
      this.refreshkey += 1;
    }
    , loadListServerside: debounce(async (event) => {
      try {
        const { srcElement: { value } } = event;
        if (value.length > 2) {
          const filter = that.filters.selected.code;
          that.$emit("loadSelect" + filter.charAt(0).toUpperCase() + filter.slice(1), that.filters.selected.code, value);
        }
      } catch (error) {
        console.error("equis" + error);
      }
    }, 50).bind(this)
    , getAndOrText(andor) {
      return andor == "AND" ? "OR" : "AND";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.filters .floating {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 1;
}
.filters .flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.filters .chipicon {
  margin-left: -12px !important;
}
</style>
<style scoped>
.v-menu__content.v-menu__content--fixed {
  position: fixed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/datatable/Filters.vue